import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonCloseAccountProps: CustomButtonProps = {
  height: '38px',
};

export const TextCheckbox: CSSObject = {
  color: 'white',
};
